export default __webpack_public_path__ + "static/media/hayato.b33395e0.png";